/** @jsx jsx */
import { jsx, css, SerializedStyles } from "@emotion/core"
import {
  Button as MuButton,
  ButtonBaseProps,
  ButtonProps,
} from "@material-ui/core"
import { Fragment, ReactNode } from "react"
import { Theme } from "../../types"
import { ColorScheme, ProgressState } from "./buttonTypes"

type Props = {
  children: string | ReactNode
  progress?: ProgressState
  testId?: string
  rootStyles?: SerializedStyles
  className?: string
  colorScheme?: ColorScheme
  component?: string
} & ButtonProps &
  ButtonBaseProps

function Button({
  children,
  progress,
  variant = "contained",
  color = "primary",
  rootStyles,
  className,
  colorScheme = "default",
  testId,
  ...buttonProps
}: Props) {
  let statusStyle = (theme: Theme) => css``
  if (progress === "success") {
    statusStyle = styles.success
  } else if (progress === "error") {
    statusStyle = styles.error
  }

  return (
    <div css={[styles.root, rootStyles]} className={className}>
      <MuButton
        variant={variant}
        color={color}
        disabled={
          progress === "loading" ||
          progress === "success" ||
          buttonProps.disabled
        }
        css={(theme) => [styles.base(colorScheme, theme), statusStyle(theme)]}
        data-testid={testId}
        {...buttonProps}
      >
        {progress === "loading" ? (
          <Fragment>
            {children}
            {"..."}
          </Fragment>
        ) : (
          children
        )}
      </MuButton>
    </div>
  )
}

export default Button

const styles = {
  root: css`
    position: relative;
    display: inline-block;
  `,
  base: (colorScheme: ColorScheme, { colors }: Theme) => css`
    box-shadow: none;
    ${colorScheme === "destructive"
      ? css`
          color: ${colors.red[100]};
          background-color: ${colors.red[600]};

          &:hover {
            color: ${colors.red[100]};
            background-color: ${colors.red[700]};
          }
        `
      : css``}
  `,
  progress: (theme: Theme) => css`
    color: ${theme.palette.success.main};
    position: absolute;
    top: 25%;
    left: 40%;
    z-index: 1;
  `,
  success: (theme: Theme) => css`
    background-color: ${theme.palette.success.main} !important;
    color: ${theme.palette.common.white} !important;
  `,
  error: (theme: Theme) => css`
    background-color: ${theme.palette.error.main} !important;
    color: ${theme.palette.common.white} !important;
  `,
}
